import { RouterProvider } from 'react-router-dom';
import type { createAppRouter } from './router';
import { AppView } from './AppView';

function App({ router }: { router: ReturnType<typeof createAppRouter> }) {
  return <AppView routerNode={<RouterProvider router={router} />} />;
}

export default App;
